module.exports = __webpack_public_path__ + "static/media/offer.png.jpg.7690426a.png";